module.exports = __webpack_public_path__ + "static/media/cpy.07c2eece.svg";